import { Expose, Transform, Type } from "class-transformer";
import { ExpenseSheetSummaryItemDto } from "./expense-sheet-summary-item.dto";
import { toEuros } from "@/utils/numberUtils";

export class ExpenseSheetSummaryDto {
  @Expose()
  @Type(() => ExpenseSheetSummaryItemDto)
  items: ExpenseSheetSummaryItemDto[];

  @Expose()
  @Transform(({ value }) => toEuros(value))
  total: number;
}
